import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "mt-2 mb-2" };
const _hoisted_2 = { class: "col fw-bold mb-2" };
const _hoisted_3 = { class: "d-flex flex-row" };
const _hoisted_4 = { class: "flex-fill" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_file_field = _resolveComponent("g-file-field");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.caption), 1),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_g_file_field, {
                    "upload-url": '/frontend/v1/forms/Processes/' + _ctx.schema.processID + '/files?source=form',
                    "delete-url": '{fileUrl}',
                    "open-url": '{fileUrl}',
                    accept: _ctx.getValueOrAttribute(_ctx.element.accept, 'FileAllowedTypes'),
                    "max-file-size": _ctx.getValueOrAttribute(_ctx.element.accept, 'FileMaxSize') * 1024 * 1024,
                    multiple: _ctx.element.isMultipleOccurs,
                    "data-member": _ctx.field.member,
                    "data-mode": 'model',
                    "data-object": _ctx.data,
                    "custom-fields": { processID: _ctx.schema.processID },
                    onDeleted: _ctx.onFilesChanged,
                    onUploaded: _ctx.onFilesChanged
                }, null, 8, ["upload-url", "accept", "max-file-size", "multiple", "data-member", "data-object", "custom-fields", "onDeleted", "onUploaded"])
            ])
        ])
    ]));
}
